module.exports = __webpack_public_path__ + "img/hengyuan.aa420463.jpeg";